import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const blogsApi = createApi({
  reducerPath: "blogsApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getBlogs: builder.query({
      query: (params = {}) => ({ url: "/blogs", params }),
    }),
    getBlog: builder.query({
      query: (slug) => `/blogs/${slug}`,
    }),
  }),
});

export const { useGetBlogsQuery, useGetBlogQuery } = blogsApi;
